parseEnumValuesDefinition